import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import {
  fetchAddCallback,
  IAddCallbackRequest,
  IAddCallbackResponse,
  IAddCallbackResponse200,
} from '../../repositories/newbuilding-calltracking/v1/add-callback';

interface IRequestCallbackDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

type TRequestCallbackParams = Omit<IAddCallbackRequest, 'clientType'>;

export async function requestCallback(
  dependencies: IRequestCallbackDependencies,
  parameters: TRequestCallbackParams,
): Promise<IAddCallbackResponse> {
  const { httpApi, logger } = dependencies;

  try {
    const { response } = await fetchAddCallback<IAddCallbackResponse200>({
      httpApi,
      parameters: {
        ...parameters,
        clientType: 'callbackOrderForm',
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
    });

    return response;
  } catch (error) {
    logger.error(error, {
      domain: 'shared.services.requestCallback()',
    });

    throw error;
  }
}
